import { mount } from 'svelte';
import { applyLangToDocument } from '$lib/i18n';
import { appUpdate } from '$lib/pwa.svelte';
import { store } from '$lib/store';
import { tenant } from '$lib/store/tenant.svelte';
import App from './App.svelte';
import './styles/tokens.css';
import './styles/global.css';

// Boot timing (spec §1.6): the store measures from this mark and prints the one console line.
performance.mark('tik-boot-start');
applyLangToDocument();
// One bundle serves every enabled site: resolve this hostname to its tenant (title, login
// hint, accent). Cached and non-blocking - it never delays mount.
tenant.boot();
// Without this a returning user keeps the version their service worker installed, forever.
appUpdate.boot({ isSignedIn: () => !!store.user });

const target = document.getElementById('app');
if (!target) throw new Error('#app root missing');

const app = mount(App, { target });

export default app;
